<template>
  <div
    class="common-dropdown"
    @click="toggleContent"
    @keydown.enter="toggleContent"
    tabindex="0"
  >
    <div class="header-container">
      <slot name="header"></slot>
      <pn-icon
        :symbol="showContent ? 'angle-small-up' : 'angle-small-down'"
        color="blue700"
        size="medium"
        solid
      ></pn-icon>
    </div>
    <div class="content-container" v-if="showContent">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showContent: false
    }
  },
  methods: {
    toggleContent() {
      this.showContent = !this.showContent
    }
  }
}
</script>

<style lang="scss">
.common-dropdown {
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 1.25em;
  width: 100%;
  border: 1px solid $gray200;
  padding: 1.25em 1em;
  margin: 1em 0;

  &:hover {
    cursor: pointer;
  }

  .header-container {
    color: $gray700;
    display: flex;
    justify-content: space-between;

    pn-icon {
      &:hover {
        cursor: pointer;
      }
    }
  }

  @media screen and (max-width: 50em) {
    .content-container {
      z-index: 2;
      position: absolute;
      background-color: white;
      border: 1px solid $gray200;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
      width: 100%;
      left: 0em;
      margin-top: 1.25em;
    }
  }

  @media screen and (min-width: 50em) {
    .content-container {
      margin-top: 1.25em;
      padding-right: 2em;
    }
  }

  @media screen and (min-width: 75em) {
    .content-container {
      margin-top: 1.25em;
      padding-right: 2em;
    }
  }
}
</style>
